import { useRef, useMemo } from 'react';
import classes from '../ReportResult/OldReportResult.module.css';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import NewRealPlayHeader from './NewRealPlayHeader';
import NewRealPlayLeftSection from './NewRealPlayLeftSection';
import NewRealPlayRightSection from './NewRealPlayRightSection';
import Transcription from '../ReportResult/Transcription';
import OldNewRealPlayHeader from './OldNewRealPlayHeader';
import OldNewRealPlayLeftSection from './OldNewRealPlayLeftSection';
import OldNewRealPlayRightSection from './OldNewRealPlayRightSection';
const OldNewReviewQualifiedRoleplay = ({ isLoadingResponse }) => {
  const playerRef = useRef(null);
  const {
    assignment_uuid,
    assigned_by_user,
    selectedScenario,
    persona_name: prospectName,
    persona_image,
  } = RealPlayRecordDataHelper();

  const userName = useMemo(
    () => `${assigned_by_user?.first_name} ${assigned_by_user?.last_name}`,
    [assigned_by_user]
  );

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <OldNewRealPlayHeader />
      </div>
      <div className={classes.gridContainer} style={{ marginTop: "20px" }}>
        <OldNewRealPlayLeftSection
          isLoadingResponse={isLoadingResponse}
          playerRef={playerRef}
          handleSeek={handleSeek}
        />
        <OldNewRealPlayRightSection isLoadingResponse={isLoadingResponse} />
      </div>
      <div className={classes.transcriptionContainer}>
        {/* Transcription*/}
        <Transcription
          assignment_uuid={assignment_uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={prospectName}
          userName={userName}
          assigned_by_user={assigned_by_user}
          client_profile_pic={persona_image}
        />
      </div>
    </div>
  );
};

export default OldNewReviewQualifiedRoleplay;